module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_spades-2.2850bf31.svg";